import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import { ForgotPasswordLastStepDefault } from "./ForgotPasswordLastStepDefault";
import ForgotPasswordLastStepBranded from "./ForgotPasswordLastStepBranded";

// Dispatcher de /confirm-email: BRANDED sob BrandScope; qualquer outro fluxo usa a tela
// Default atual (movida sem edição de conteúdo). Nome exportado preservado p/ o Routes.
export const ForgotPasswordLastStep: React.FC = () => {
  const { variant, brand } = useScreenVariant();

  if (variant === ScreenVariant.BRANDED) {
    return (
      <BrandScope brand={brand}>
        <ForgotPasswordLastStepBranded />
      </BrandScope>
    );
  }

  return <ForgotPasswordLastStepDefault />;
};

export default ForgotPasswordLastStep;
